import { ReadonlyVec3 } from 'gl-matrix';
import { useRecoilValue } from 'recoil';
import {
    environmentState,
    lowerSideViewState,
    mainViewState,
    upperSideViewState,
} from '~/state/atoms/engineAtoms';

export default function useViewportFocus() {
    const environment = useRecoilValue(environmentState);
    const mainView = useRecoilValue(mainViewState);
    const upperSideView = useRecoilValue(upperSideViewState);
    const lowerSideView = useRecoilValue(lowerSideViewState);

    const focusOnStructure = (roiNumber: number) => {
        if (
            environment &&
            mainView &&
            upperSideView &&
            lowerSideView &&
            environment.structureSet
        ) {
            const roi = environment.structureSet.getRoi(roiNumber);
            if (roi && !roi.isEmpty && roi.texture) {
                environment.panZoom.focusTo(
                    mainView,
                    upperSideView,
                    lowerSideView,
                    roi.texture.contentBoundingBox
                );
            }
        }
    };

    /**
     * Centers all viewports on a specific point (Marker) in 3D space by
     * panning and zooming all views to the target location.
     *
     * Typical use case: Focusing on point-type ROIs (MARKER, ISOCENTER, REGISTRATION).
     *
     * @param point - The 3D coordinates to focus on in patient space (mm)
     */
    const focusOnPoint = (point: ReadonlyVec3) => {
        if (!environment || !mainView || !upperSideView || !lowerSideView) {
            return;
        }
        environment.panZoom.focusToPoint(
            mainView,
            upperSideView,
            lowerSideView,
            point
        );
    };

    return { focusOnStructure, focusOnPoint };
}
